import BaseResource from './index'

export default class MarketResource extends BaseResource {
    static endpoint = '/markets'
    static allOnce = true
    static cacheMaxAge = 3600
}
